// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1pNkx","header":"ClearentDisclaimer_header__HDirJ","inner":"ClearentDisclaimer_inner__1tfC1"};